import React, { useEffect, useRef, useState } from "react";
import "./HotelSearchBar.scss";
import InputBox from "../../components/InputBox";
import Label from "../../components/Label";
import CustomButton from "../../components/CustomButton";
import HotelGuestDropDown from "../HotelGuestDropDown";
import {
  handleGetAvailHotelApiCall,
  handleGetHotelCitySuggestionApiCall,
} from "../../utils/ApiCalls";
import DisplaySuggesition from "../../components/DisplaySuggesition";

const HotelSearchBar = ({
  hanldeSetAvailHotelList,
  handleSetResultForData,
  handleSetInitialApiCall,
}) => {
  const [guestDropDown, setGuestDropDown] = useState(false);
  const [formData, setFormData] = useState({
    city: "",
    checkIn: "",
    checkOut: "",
  });
  const [count, setCount] = useState({
    adultCount: 2,
    childrenCount: 0,
    roomCount: 1,
  });
  const [displayGuest, setDisplayGuest] = useState({
    guest: 2,
    room: 1,
  });
  const [suggestionList, setSuggestionList] = useState([]);
  const [isSuggestionVisible, setIsSuggestionVisible] = useState(false);
  const handleGuestOnClick = (e) => {
    setGuestDropDown((prevState) => !prevState);
  };
  const handleCountClick = (name, type) => {
    if (type === "add") {
      setCount((prevState) => {
        return {
          ...prevState,
          [name]: count[name] + 1,
        };
      });
    } else {
      if (count[name] > 0) {
        setCount((prevState) => {
          return {
            ...prevState,
            [name]: count[name] - 1,
          };
        });
      }
    }
  };

  const handleGuestApplyBtn = () => {
    setDisplayGuest({
      ...displayGuest,
      guest: count.adultCount + count.childrenCount,
      room: count.roomCount,
    });
    handleGuestOnClick();
  };

  const handleGuestReset = () => {
    setCount({
      ...count,
      adultCount: 2,
      childrenCount: 0,
      roomCount: 1,
    });
  };
  const handleApiCall = () => {
    const response = handleGetHotelCitySuggestionApiCall();
    response.then((res) => {
      console.log(res);
      if (res?.status === 200) {
        setSuggestionList(res?.data);
      }
    });
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    if (name === "city") {
      setIsSuggestionVisible(true);
    }
    setFormData((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const handleSuggestionOnClick = (value) => {
    console.log(value);
    setFormData((prevState) => {
      return {
        ...prevState,
        city: value,
      };
    });
    setIsSuggestionVisible(false);
  };

  useEffect(() => {
    handleApiCall();
  }, []);

  const handleSearch = () => {
    const dataObj = {
      city: formData.city,
      adultCount: count.adultCount,
      childrenCount: count.childrenCount,
      roomCount: count.roomCount,
    };
    const response = handleGetAvailHotelApiCall(dataObj);
    response.then((res) => {
      // console.log(res);
      handleSetInitialApiCall(true);
      hanldeSetAvailHotelList(res?.data ? res?.data : []);
      handleSetResultForData({
        city: dataObj.city,
        checkIn: formData.checkIn,
        checkOut: formData.checkOut,
        adultCount: dataObj.adultCount,
        childrenCount: dataObj.childrenCount,
        roomCount: dataObj.roomCount,
      });
    });
  };

  return (
    <div className="HotelSearchBar">
      <div className="HotelSearchBar__container-1">
        <span class="material-symbols-outlined search-icon icon">search</span>
        <div className="input-wrapper">
          <Label value="Enter place" />
          <InputBox
            type="text"
            customClass="hotel-search-text-input"
            placeHolder={"Type here..."}
            name="city"
            onChange={handleOnChange}
            autocomplete="off"
            value={formData.city}
          />
        </div>
        <DisplaySuggesition
          dataList={suggestionList}
          customClass="hotel_city_suggestion"
          onClick={handleSuggestionOnClick}
          inputState={formData.city}
          visible={isSuggestionVisible}
        />
      </div>
      <span className="split-line" />
      <div className="HotelSearchBar__container-2">
        <span class="material-symbols-outlined icon">calendar_month</span>
        <div className="input-wrapper">
          <Label value="Check in" />
          <InputBox
            type="date"
            customClass="hotel-search-date-input"
            name="checkIn"
            onChange={handleOnChange}
          />
        </div>
      </div>
      <span className="split-line" />
      <div className="HotelSearchBar__container-3">
        <span class="material-symbols-outlined icon">calendar_month</span>
        <div className="input-wrapper">
          <Label value="Check Out" />
          <InputBox
            type="date"
            customClass="hotel-search-date-input"
            name="checkOut"
            onChange={handleOnChange}
          />
        </div>
      </div>
      <span className="split-line" />
      <div className="HotelSearchBar__container-4" onClick={handleGuestOnClick}>
        <span class="material-symbols-outlined icon">bed</span>
        <div className="input-wrapper">
          <p>Guests and rooms</p>
          <p>{`${displayGuest.guest} Guest, ${displayGuest.room} Room`}</p>
        </div>
        {guestDropDown && (
          <HotelGuestDropDown
            count={count}
            handleCountClick={handleCountClick}
            handleGuestApplyBtn={handleGuestApplyBtn}
            handleGuestReset={handleGuestReset}
            customClass="guest_drop_down"
          />
        )}
      </div>
      <span className="split-line" />
      <div className="HotelSearchBar__container-4">
        <CustomButton
          type="submit"
          value={"Search"}
          customClassName={`hotel-search-btn`}
          onClick={handleSearch}
        />
      </div>
    </div>
  );
};

export default HotelSearchBar;
